import { render, staticRenderFns } from "./ProjectDataForm.vue?vue&type=template&id=59a156bf&"
import script from "./ProjectDataForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports